
// import { timeFormat } from "@/utils/time";
// import store from "@/store";
// import dict from "@/config";

export const getThemeColumns = () => {
	return [
		// {
		// 	title: "主题头像",
		// 	dataIndex: "icon_url",
		// 	align: "center",
		// 	scopedSlots: { customRender: "icon_url" },
		// },
		// {
		// 	title: "主题背景",
		// 	dataIndex: "background_image_url",
		// 	align: "center",
		// 	scopedSlots: { customRender: "background_image_url" },
		// },
		{
			title: "主题名称",
			dataIndex: "name",
			align: "center",
			customRender: (text) => {
				return text || "--";
			},
		},
		{
			title: "主题状态",
			dataIndex: "status",
			align: "center",
			customCell: (record) => {
				return { class: `STATUS_${record.status}` };
			},
			customRender: (text) => {
				return `● ${text === "ACTIVE" ? "使用中" : "已归档"}`;
			},
		},
		{
			title: "主题说明",
			dataIndex: "description",
			// align: "center",
			width: 300,
			customRender: (text) => {
				return text || "--";
			},
		},
		{
			title: "操作",
			dataIndex: "operation",
			align: "center",
			scopedSlots: { customRender: "operation" },
		},
	];
};


export default {
	getThemeColumns,
};
